import React from 'react';
import { Modal, Button } from 'antd';
import { getWspVariableMap } from 'services/NotificationTemplatesService';
import useStyles from './styles';

interface WspMappingModalProps {
  classes: ReturnType<typeof useStyles>;
  open: boolean;
  onClose: () => void;
  templateName: string;
  stateCode: number;
  stateName: string;
}

const WspMappingModal = ({
  classes,
  open,
  onClose,
  templateName,
  stateCode,
  stateName,
}: WspMappingModalProps) => {
  const rows = getWspVariableMap(templateName);

  const components = rows.reduce<Record<string, typeof rows>>((acc, row) => {
    (acc[row.component] = acc[row.component] || []).push(row);
    return acc;
  }, {});

  return (
    <Modal
      title={`Mapeo de variables — ${templateName}`}
      open={open}
      onCancel={onClose}
      width={480}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          Entendido
        </Button>,
      ]}
    >
      <div style={{ fontSize: 12.5, color: '#8c8c8c', marginBottom: 8 }}>
        {stateName} ({stateCode})
      </div>
      {Object.entries(components).map(([component, componentRows]) => (
        <div key={component}>
          <div className={classes.mapComp}>{component}</div>
          {componentRows.map((row) => (
            <div className={classes.maprow} key={`${component}-${row.param}`}>
              <span className={classes.mapKey}>{row.param}</span>
              <span className={classes.mapArrow}>←</span>
              <span className={classes.mapVal}>{row.variable}</span>
            </div>
          ))}
        </div>
      ))}
      <div className={classes.note} style={{ marginTop: 16 }}>
        🔒
        <div>Este mapeo es de solo lectura.</div>
      </div>
    </Modal>
  );
};

export default WspMappingModal;
